import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import LocaleStrings from "Languages";
import { Field, reduxForm, reset } from "redux-form";
import Button from "react-bootstrap-button-loader";
import { IMAGE_PATH, COMMON_FAIL_MESSAGE, validateEmail } from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  BaseComponent,
  LABEL_POSITION_TOP,
  required,
  noSpecialChar,
  email,
  number,
  alphaNumeric,
  phoneNumber,
  maxLength,
  minLength,
  minValue,
  maxValue,
  trim,
} from "BaseComponent";
import { confirmAlert } from "react-confirm-alert";

import Confirm from "./confirm";

import {
  saveOptionStateUpgrade,
  showConfirmModal,
  saveSelectedPlan,
  fetchSiteDetails,
  redeployFunction,
} from "../../actions";

class Upgrade extends BaseComponent {
  constructor(props) {
    super(props);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.state = {
      loading: false,
      plan: [
        {
          id: 0,
          name: "Free",
          value: "free",
          options: [],
          description: "Free",
          price: 0,
          currency: "$",
          // isselected: false,
        },
        {
          id: 1,
          name: "Plan 1",
          value: "plan1",
          options: ["Lorem ipsum a", "Lorem ipsum b"],
          description: "Required approx. 10hrs design & development time",
          price: 120,
          currency: "$",
          // isselected: false,
        },
        {
          id: 2,
          name: "Plan 2",
          value: "plan2",
          options: [
            "Lorem ipsum a",
            "Lorem ipsum b",
            "Lorem ipsum c",
            "Lorem ipsum d",
          ],
          description: "Required approx. 15hrs design & development time",
          price: 150,
          currency: "$",
          // isselected: false,
        },
        {
          id: 3,
          name: "Plan 3",
          value: "plan3",
          options: [
            "Lorem ipsum a",
            "Lorem ipsum b",
            "Lorem ipsum c",
            "Lorem ipsum d",
            "Lorem ipsum e",
            "Lorem ipsum f",
          ],
          description: "Required approx. 40hrs design & development time",
          price: 200,
          currency: "$",
          // isselected: false,
        },
      ],
      selectedPlan:
        this.props.selectedPlan && !_.isEmpty(this.props.selectedPlan)
          ? this.props.selectedPlan
          : {},
    };
  }

  componentDidMount() {
    this.props.fetchSiteDetails(this.props.session);
  }

  onSubmitForm(values) {
    // // this.setState({ loading: true });

    // // let { TemplatesWizardData, optionStateUpgrade } = this.props;
    // // let data = TemplatesWizardData;
    // // data.resource.publish = {
    // //     option: optionStateUpgrade.free? "free" : "paid",
    // //     selectedplan: this.state.selectedPlan,
    // // };
    // // this.props.saveTemplatesWizardData(data);

    // setTimeout(() => {

    //     this.openConfirmModal();
    // }, 1);

    let { selectedPlan } = this.props;
    let redeployData = {};

    if (selectedPlan && !_.isEmpty(selectedPlan)) {
      redeployData = { selectedplan: selectedPlan };
    } else {
      redeployData = { selectedplan: {} };
    }

    this.props.redeployFunction({
      redeploy: true,
      from: "upgrade",
      data: redeployData,
    });

    setTimeout(() => {
      this.redirectToWizard();
    }, 100);
  }

  redirectToWizard = () => {
    var path = "wizard";
    this.props.history.push(`/dashboard/website/${path}`);
  };

  openConfirmModal = () => {
    this.props.showConfirmModal({ showModal: true });
  };

  getPlanIndex = () => {
    let { siteDetails } = this.props;

    let plan_purchase = "";
    if (
      siteDetails &&
      siteDetails.resource &&
      !_.isEmpty(siteDetails.resource) &&
      siteDetails.resource[0].plan_purchase
    ) {
      plan_purchase = siteDetails.resource[0].plan_purchase;
    }
    let plan_index = 0;
    if (plan_purchase !== "free") {
      plan_index = plan_purchase.replace(/[^0-9]/g, "");
    }

    return plan_index;
  };

  alreadyPurchasedAlert = () => {
    confirmAlert({
      title: "Plan already purchased!",
      message: "Please select a higher value plan.",
      confirmLabel: "",
      cancelLabel: "Close",
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {},
        },
        {
          label: "Close",
          onClick: () => {},
        },
      ],
    });
  };

  selectPlan = (e, index, item) => {
    let plan_index = this.getPlanIndex();

    if (item.id > plan_index) {
      this.props.saveSelectedPlan(item);
      this.setState({ selectedPlan: item });
    } else {
      this.alreadyPurchasedAlert();
      this.props.saveSelectedPlan({});
      this.setState({ selectedPlan: {} });
    }
  };

  renderPlans = () => {
    let { plan } = this.state;
    let { selectedPlan } = this.props;

    let plan_index = this.getPlanIndex();
    let planArr = [];

    _.map(plan, (item, index) => {
      if (index > 0) {
        let currentPackage = false;
        if (item.id == plan_index) {
          currentPackage = true;
        }

        let styleHead = {
          border: "solid 1px #919191",
          padding: 15,
          color: "#6a54c9",
          backgroundColor: "#FFF",
          fontWeight: 600,
        };
        let styleBody = {
          height: 300,
          border: "solid 1px #919191",
          padding: 15,
          color: "#767988",
          backgroundColor: "#FFF",
          fontWeight: 600,
        };

        if (currentPackage) {
          styleHead = {
            border: "solid 1px #919191",
            padding: 15,
            color: "#6a54c9",
            backgroundColor: "#E1E6EC",
            fontWeight: 600,
          };
        }

        if (!_.isEmpty(selectedPlan) && selectedPlan.id === item.id) {
          styleHead = {
            border: "solid 1px #6a54c9",
            padding: 15,
            color: "#FFF",
            backgroundColor: "#6a54c9",
            fontWeight: 600,
          };
          styleBody = {
            height: 300,
            border: "solid 1px #6a54c9",
            padding: 15,
            color: "#767988",
            backgroundColor: "#FFF",
            fontWeight: 600,
          };
        }

        let styleCurrentPackageP = {
          padding: 15,
          color: "#767988",
          fontWeight: 600,
        };

        planArr.push(
          <div
            className="col-md-4 pointer"
            // style={{ width: "30%" }}
            onClick={(e) => this.selectPlan(e, index, item)}
          >
            <div className="col-md-12 setting-company-section-heading text-center mt-0">
              {currentPackage ? (
                <p style={styleCurrentPackageP}> Current Package </p>
              ) : (
                <p style={{ padding: 25 }}> </p>
              )}
            </div>

            <div
              className="col-md-12 setting-company-section-heading text-center mt-0"
              style={styleHead}
            >
              {item.name}
            </div>
            <div
              className="col-md-12 setting-company-section-heading mt-0 p-20"
              style={styleBody}
            >
              {_.map(item.options, (opt) => {
                return <div> {"- " + opt} </div>;
              })}

              <div className="mt-40"> {item.description} </div>
            </div>
            <div
              className="col-md-12 setting-company-section-heading text-center mt-0"
              style={styleHead}
            >
              <div> {item.currency + item.price} </div>
            </div>
          </div>
        );
      }
    });

    return planArr;
  };

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      editMode,
      initialValues,
      confirmModal,
      siteDetails,
      deviceSize,
    } = this.props;
    let { selectedPlan } = this.state;

    let disabled = true;
    let plan_index = this.getPlanIndex();
    if (!_.isEmpty(selectedPlan) && selectedPlan.id > plan_index) {
      disabled = false;
    }

    return (
      <div
        className="panel-body scrollable-content"
        // style={{ height: deviceSize.height - 70 }}
      >
        {confirmModal.showModal === true ? (
          <Confirm history={this.props.history} />
        ) : (
          ""
        )}
        <form onSubmit={handleSubmit(this.onSubmitForm)}>
          <div className="row" style={{ width: "70%" }}>
            <div className="col-md-12">
              <label className="heading-theme-text-color">
                Upgrade customization package
              </label>

              <div
                className="col-md-12 p-15"
                style={{
                  border: "solid 1px #A9ABB5",
                  borderRadius: 10,
                }}
              >
                {this.renderPlans()}

                <div className="text-center">
                  <Button
                    bsStyle=""
                    className="btn-custom-blue mt-120 mb-10"
                    loading={this.state.loading}
                    disabled={disabled}
                    type="submit"
                  >
                    Upgrade and Re-Deploy
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};

  return errors;
}

function mapStateToProps(state) {
  var initVals = null;
  var toEdit = false;

  return {
    session: state.session,
    initialValues: initVals,
    editMode: toEdit,
    confirmModal: state.confirmModal,
    selectedPlan: state.selectedPlan,
    siteDetails: state.siteDetails,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  saveOptionStateUpgrade,
  showConfirmModal,
  saveSelectedPlan,
  fetchSiteDetails,
  redeployFunction,
})(
  reduxForm({
    validate,
    form: "TemplatesUpgradeForm",
    enableReinitialize: true,
    // keepDirtyOnReinitialize: true
  })(Upgrade)
);
